<template>
  
  <div>

  <QRListar></QRListar>
  

</div>
</template>

<script>



import QRListar from '../components/Archivo/QRListar';


export default {

    components:{QRListar},

   

 }


</script>






